<template>
    <div class="page-home">
        <CBNavbar @navbar-click="onNavbarClick" />
        <div class="page">
            <div class="value1">
              <span class="Stories">Stories</span>
              <span class="Grows"> Flow Value Grows</span>
            </div>
            <div class="value2">{{$t('value1')}}</div>
            <div class="value3">
              <div class="value3_content1">{{$t('value2')}}</div>
              <div class="value3_content2" id="About">{{$t('value47')}}</div>
              <div class="value3_content3">{{$t('value3')}}</div>
              <img src="@/assets/images/background.png" alt="background" class="background">
            </div>
            <div class="value4">
              <div class="value4_content1">{{$t('value4')}}</div>
              <div class="value4_content2">
                <span>{{$t('value5')}}</span>
                <span style="color: #fff;">{{$t('value6')}}</span>
              </div>
              <img src="@/assets/images/background2.png" alt="background2" class="background2">
              <div class="value4_content3">{{$t('value7')}}</div>
              <img src="@/assets/images/background3.png" alt="background3" class="background3">
              <div class="value4_content4">{{$t('value8')}}</div>
              <div class="value4_content5">{{$t('value9')}}</div>
              <div class="value4_content6">{{$t('value10')}}</div>
            </div>
            <div class="value5">
              <div class="value5_content1">{{$t('value11')}}</div>
              <!-- <div class="value5_content2">
                <div class="slider">
                    <img src="@/assets/images/background5.png" alt="background5" class="background5">
                    <img src="@/assets/images/background6.png" alt="background6" class="background6">
                    <img src="@/assets/images/background6.png" alt="background7" class="background7">
                </div>
              </div> -->
              <!-- <el-carousel :interval="3000" type="card" height="147px" autoplay>
                <el-carousel-item v-for="(img, index) in imgList" :key="index">
                  <img :src="img.url" :alt="'image-' + index" class="carousel-img">
                </el-carousel-item>
              </el-carousel> -->
              <div class="value5_content2">
                <!-- <vue-seamless-scroll
                  :data="listData"
                  :class-option="classOption"
                  style="height: 70%;overflow: hidden;"
                >
                  <ul class="ul-item">
                    <li class="li-item" v-for="(item, index) in imgList" :key="index">
                      <img :src="item.url" :alt="'image-' + index" class="carousel-img">
                    </li>
                  </ul>
                </vue-seamless-scroll> -->
                <vue-seamless-scroll
                  :data="listData"
                  :class-option="classOption"
                  style="overflow: hidden;"
                >
                  <div class="carousel-img-fn">
                    <img  v-for="(item, index) in imgList" :key="index" :src="item.url" :alt="'image-' + index" class="carousel-img">
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
            <div class="value6" id="TokenEconomic">
              <div class="value5_content1">{{$t('value12')}}</div>
              <img src="@/assets/images/background8.png" alt="background8" class="background8">
              <div class="value5_content2">
                {{$t('value13')}} <br/>
                {{$t('value14')}}<br/>
                {{$t('value15')}}<br/>
                {{$t('value16')}}<br/>
                {{$t('value17')}}<br/>
                {{$t('value18')}}<br/>
                {{$t('value19')}}
              </div>
              <div class="value5_content3">{{$t('value20')}}</div>
              <img src="@/assets/images/background9.png" alt="background9" class="background9">
              <div class="value5_content4">
                {{$t('value21')}}<br/>
                {{$t('value22')}}<br/>
                {{$t('value23')}}<br/><br/>

                {{$t('value24')}}<br/>
                {{$t('value25')}}<br/>
                {{$t('value26')}}
              </div>
            </div>
            <div class="value7" id="Governance">
              <div class="value6_content1">{{$t('value27')}}</div>
              <div class="value6_content11">
                <img src="@/assets/images/background26.png" alt="background26" class="background26">
                <div class="value6_content11_div">
                  {{$t('value28')}}
                </div>
              </div>
              <div class="value6_content2">
                <img src="@/assets/images/backgroundImage.png" alt="backgroundImage" class="backgroundImage">
                <div class="value6_content2_div">{{$t('value29')}}</div>
              </div>
              <div class="value6_content3">
                <img src="@/assets/images/backgroundImage1.png" alt="backgroundImage1" class="backgroundImage1">
                <div class="value6_content3_div">
                  {{$t('value30')}}
                </div>
              </div>
              <div class="value6_content4">
                <img src="@/assets/images/backgroundImage2.png" alt="backgroundImage2" class="backgroundImage2">
                <div class="value6_content4_div">{{$t('value31')}}</div>
              </div>
              <div class="value6_content5">
                <img src="@/assets/images/Backpack.png" alt="Backpack" class="Backpack">
                <div class="value6_content5_div">{{$t('value32')}}</div>
              </div>
              <div class="value6_content6">
                <img src="@/assets/images/Backpack1.png" alt="Backpack1" class="Backpack1">
                <div class="value6_content6_div">{{$t('value33')}}</div>
              </div>
            </div>
            <div class="value8">
              <!-- circle.png -->
              <div class="value8_content1">
                {{$t('value34')}}
              </div>
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="$t(activity.timestamp)">
                  {{activity.content}}
                </el-timeline-item>
              </el-timeline>
            </div>
            <div class="value9">
              <div class="value9_content1">
                <span class="Stories">{{$t('value35')}}</span>
                <span class="Grows"> {{$t('value36')}}</span>
              </div>
              <div class="value9_content2">
                <div class="value9_content2_one">
                  <div class="value9_content2_one_Twitter"  @click="imgClick('Twitter')">
                    <img src="@/assets/images/Twitter.png" alt="Twitter" class="Twitter">
                    <div class="Twitter_Twitter">Twitter</div>
                  </div>
                  <div class="value9_content2_one_telegram"  @click="imgClick('telegram')">
                    <img src="@/assets/images/telegram.png" alt="telegram" class="telegram">
                    <div class="Telegram_Telegram">Telegram</div>
                  </div>
                </div>
                <div class="value9_content2_two">
                  <div class="value9_content2_two_Medium"  @click="imgClick('Medium')">
                    <img src="@/assets/images/Medium.png" alt="Medium" class="Medium">
                    <div class="Medium_Medium">Medium</div>
                  </div>
                  <div class="value9_content2_two_github"  @click="imgClick('github')">
                    <img src="@/assets/images/github.png" alt="github" class="github">
                    <div class="github_github">GitHub</div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import CBNavbar from '@/components/navbar'
import { mapState, mapGetters } from 'vuex'
import vueSeamlessScroll from 'vue-seamless-scroll'
import { getToken } from '@/utils/auth'
// import { MessageBox } from 'element-ui';
// import { locationHrefIndex } from '@/web3/index'
import './Home.css'
export default {
    name: 'HomePage',
    components: {
        CBNavbar,
        vueSeamlessScroll
    },
    data() {
        return {
          imgList: [
            { url: require('@/assets/images/bg8.png') },
            { url: require('@/assets/images/bg9.png') },
            { url: require('@/assets/images/bg10.png') },
            { url: require('@/assets/images/bg19.png') },
            { url: require('@/assets/images/bg12.png') },
            { url: require('@/assets/images/bg13.png') },
            { url: require('@/assets/images/bg14.png') },
            { url: require('@/assets/images/bg15.png') },
            { url: require('@/assets/images/bg16.png') },
            { url: require('@/assets/images/bg17.png') },
            { url: require('@/assets/images/bg18.png') }
          ],
          listData: [1, 2, 3, 4, 5, 6],
          classOption: {
            limitMoveNum: 1,
            direction: 3,
            step: 0.5
          },
          activities: [{
            content: '2025 Q1',
            timestamp: 'value41',
            color: '#4200FF'
          }, {
            content: '2025 Q2',
            timestamp: 'value42',
            color: '#4200FF'
          }, {
            content: '2025 Q3',
            timestamp: 'value43',
            color: '#4200FF'
          }, {
            content: '2025 Q4',
            timestamp: 'value44',
            color: '#4200FF'
          }, {
            content: '2026 Q1-Q2',
            timestamp: 'value45',
            color: '#4200FF'
          }],
          offTimer:null,
        }
    },
    computed: {
        ...mapState(['address']),
        ...mapGetters(['isLogin']),
    },
    methods: {
      imgClick(value){
        switch (value) {
          case "Twitter":
            window.location.href="https://x.com/metaflowlabs?s=11&t=TdwcgclQrTygwiCleIZO9w"
            break;
          case "telegram":
            window.location.href="https://t.me/+-3XFpuGFBsowNmJl"
            break;
          case "Medium":
            window.location.href="https://medium.com/@Metaflow.network"
            break;
          case "github":
            
            break;
          default:
            break;
        }
      },
      onNavbarClick(value) {
        console.log('Navbar clicked with value:', value); // 处理事件的方法，接收传递的值
        const element = document.getElementById(value);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
        }
        // 在这里可以执行其他逻辑
      }
    },
    mounted(){
      this.offTimer=setInterval(async ()=>{
        // console.log('执行');
          getToken()
      },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
      clearInterval(this.offTimer);  
      this.offTimer=null
    },
}
</script>
<style scoped lang="less">

</style>